import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-golf-ball",
  "use": "icon-si-glyph-golf-ball-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-golf-ball\" id=\"icon-si-glyph-golf-ball\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>147</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g transform=\"translate(3.000000, 0.000000)\" fill=\"#434343\">\n            <path d=\"M3.031,12 L5.031,13.969 L5.031,16 L5.938,16 L5.938,13.969 L7.938,12 L3.031,12 Z\" class=\"si-glyph-fill\" />\n            <path d=\"M0.031,5.453 C0.031,8.465 2.472,10.906 5.484,10.906 C8.496,10.906 10.937,8.465 10.937,5.453 C10.937,2.441 8.496,0 5.484,0 C2.472,0 0.031,2.441 0.031,5.453 Z\" class=\"si-glyph-fill\" />\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-golf-ball.svg
// module id = 9OJ7
// module chunks = 62